import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { StorageService } from 'src/app/Services/storage.service';

@Component({
  selector: 'g10-complaint-ratings',
  templateUrl: './complaint-ratings.component.html',
  styleUrls: ['./complaint-ratings.component.css']
})
export class ComplaintRatingsComponent implements OnInit {

  public _activeMenu: string = 'vehicle';

  public noDataFoundEnable: boolean = false;

  pageNum = 1;

  /* Pagination */
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  };
  public filterData = {};
  public showTable: boolean = false;
  public tableData: any = [];
  public vehicleCols: any = [
    { key: '#', display: '#' },
    {
      key: 'vehRegNo', display: 'Reg no',
      config: {
        isVehicle: true,
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'compRating', display: '#Complaint' ,headerConfig:{ isDefault: true}},
    {
      key: 'lastUpdate', display: 'Last complaint date', config: {
        isDate: true,
        format: 'dd/MM/YYYY'
      },
      headerConfig:{ isDefault: true}
    },
  ];
  public driverCols: any = [
    { key: '#', display: '#' },
    {
      key: 'name', display: 'Driver name',headerConfig:{ isDefault: true}
    },
    { key: 'compRating', display: '#Complaint' },
    {
      key: 'lastUpdate', display: 'Last complaint date', config: {
        isDate: true,
        format: 'dd/MM/YYYY'
      },
      headerConfig:{ isDefault: true}
    },
  ];
  public cols: any = [];


  constructor(
    private api: ApiService,
  ) {

  }


  ngOnInit(): void {
    this.getComplaintRecords();
  }

  changeMenu(activeMenu) {
    this._activeMenu = activeMenu;
    this.getComplaintRecords();
  }

  getComplaintRecords(page = 1, limit = 10, filter?) {
    let obj = {
      page: page,
      limit: limit,
      type: this._activeMenu,
    }
    this.api.transportManagerComplaintRatings(obj).then((res: any) => {
      if (res && res['status'] == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.processTableData(res['data'][0]);
          this.processPagination(res, obj);
        }
        else {
          this.tableData = [];
          this.showTable = true;
          this.noDataFoundEnable = true;
        }
      }
      else {
        this.tableData = [];
        this.showTable = true;
        this.noDataFoundEnable = true;
      }
    })
  }


  processTableData(data) {
    this.showTable = false;
    if (this._activeMenu == 'vehicle') this.cols = this.vehicleCols;
    else this.cols = this.driverCols;
    this.tableData = Object.keys(data).map((res: any) => {
      let item = data[res];
      let obj = {
        compRating: item.compRating == 0 || item.compRating ? item.compRating : '',
        lastUpdate: item.updatedAt ? item.updatedAt : '',
      }
      if (this._activeMenu == 'vehicle') obj['vehRegNo'] = item['vehRegNo'] ? item['vehRegNo'] : '';
      else if (this._activeMenu == 'driver') obj['name'] = item['name'] ? item['name'] : '';

      return obj;
    });
    setTimeout(() => { this.showTable = true; this.noDataFoundEnable = true; }, 100);
  }


  processPagination(data, req) {
    this.showTable = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.showTable = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    let filterObj = Object.keys(this.filterData).length > 0 ? this.filterData : false;
    this.getComplaintRecords(data.page, data.limit, filterObj);  // (data.page,data.limit,'search') use third parameter to get results for search inputs
  }

}
